import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './polyfill';
import 'normalize.css';
import 'sanitize.css';
import './index.css';
export var disableReactDevTools = function () {
    var noop = function () { return undefined; };
    var DEV_TOOLS = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (typeof DEV_TOOLS === 'object') {
        for (var _i = 0, _a = Object.entries(DEV_TOOLS); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            DEV_TOOLS[key] = typeof value === 'function' ? noop : null;
        }
    }
};
// disableReactDevTools()
ReactDOM.render(React.createElement(App, null), document.getElementById('root'));
// registerServiceWorker()
unregisterServiceWorker(); // para eliminar el uso de cache que da problemas cuando se actualiza el contenido
// Hot reload
var hotModule = module.hot; // tslint:disable-line:no-any
if (hotModule) {
    hotModule.accept();
}
// Sentry
if (process.env.NODE_ENV === 'production') {
    // registerServiceWorker()
    // unregisterServiceWorker() // para eliminar el uso de cache que da problemas cuando se actualiza el contenido
    /*require('raven-js')
      .config('https://66b3256fb40e4783ad2458f3a13226aa@sentry.io/219864')
      .install()*/
}
// console.clear()



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 626
// module chunks = 0